/* src/app/centrui/src/app/components/centrui-menu/centrui-menu.component.scss */
:root {
  --app-height: 100%;
}
#editModeOverlay {
  position: absolute;
  height: 100vh;
  width: 6.3rem;
  background-color: white;
  opacity: 0.8;
  z-index: 99999 !important;
  top: 0;
  left: 0;
}
.menu-container {
  height: 100vh;
  min-height: 44rem;
  width: 6.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  background: #FFFFFF;
  box-shadow: 0rem 0.375rem 0.375rem rgba(0, 0, 0, 0.13), 0rem 0.625rem 0.625rem rgba(0, 0, 0, 0.09);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}
.menu-container .menu-app-icon {
  width: 6.25rem;
  height: 6.25rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  position: relative;
  border-bottom: 0.0625rem solid #EBEBEB;
}
.menu-container .menu-app-icon img {
  width: 2.6875rem;
  height: 2.6875rem;
  display: block;
}
.menu-container .menu-app-icon:hover {
  cursor: pointer;
}
.menu-container .menu-app-icon:focus {
  border: none;
  outline: none;
}
.menu-container .menu-items-container {
  height: auto;
}
.menu-container .menu-items-container .menu-item {
  width: 5.75rem;
  height: 6.25rem;
  border-left: 0.25rem solid transparent;
  border-right: 0.25rem solid transparent;
  border-bottom: 0.0625rem solid #EBEBEB;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  position: relative;
  transition: all 300ms cubic-bezier(0, 0.6, 0.4, 1);
}
.menu-container .menu-items-container .menu-item:hover {
  cursor: pointer;
  background: #F5F7FA;
}
.menu-container .menu-items-container .menu-item.active {
  border-left: 0.25rem solid #1E31BF;
  background: #F5F7FA;
}
.menu-container .menu-items-container .menu-item:first-of-type {
  border-top: 0.0625rem solid #EBEBEB;
}
.menu-container .menu-items-container .menu-item:focus {
  outline: none;
}
.menu-container .menu-items-container .menu-item .nav-icon svg {
  stroke: #1E31BF;
  color: #1E31BF;
}
.menu-container .menu-items-container .menu-item .nav-icon svg rect,
.menu-container .menu-items-container .menu-item .nav-icon svg circle,
.menu-container .menu-items-container .menu-item .nav-icon svg path {
  stroke: #1E31BF;
  color: #1E31BF;
}
.menu-container .menu-items-container .menu-item .needsStroke svg {
  stroke: #1E31BF;
  color: #1E31BF;
}
.menu-container .menu-items-container .menu-item .needsStroke svg rect,
.menu-container .menu-items-container .menu-item .needsStroke svg circle,
.menu-container .menu-items-container .menu-item .needsStroke svg path {
  stroke: #1E31BF;
  color: #1E31BF;
}
.menu-container .menu-items-container .menu-item .needsFill svg {
  fill: #BCC6FF;
  color: #BCC6FF;
}
.menu-container .menu-items-container .menu-item .needsFill svg rect,
.menu-container .menu-items-container .menu-item .needsFill svg circle,
.menu-container .menu-items-container .menu-item .needsFill svg path {
  fill: #BCC6FF;
  color: #BCC6FF;
}
.menu-container .menu-items-container .menu-item .menu-icon-svg {
  color: #020F6E;
}
.menu-container .menu-items-container .menu-item .menu-icon-svg svg {
  width: 1.25rem;
  height: 1.25rem;
}
.menu-container .menu-items-container .menu-item .menu-icon-svg[data-icon="new/settings-01.svg"] svg {
  width: 1.35rem;
  height: 1.35rem;
}
.menu-container .menu-items-container .menu-item .menu-icon-svg[data-icon="new/activity-03.svg"] svg {
  width: 1.3rem;
  height: 1.3rem;
}
.menu-container .menu-help-container {
  width: 6rem;
  height: 6.25rem;
  border-left: 0.25rem solid transparent;
  border-top: 0.0625rem solid #EBEBEB;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  position: relative;
  transition: all 300ms cubic-bezier(0, 0.6, 0.4, 1);
}
.menu-container .menu-help-container ::ng-deep svg-icon svg {
  height: 1.5rem !important;
  width: 1.5rem !important;
}
.menu-container .menu-help-container ::ng-deep svg-icon {
  color: #1E31BF !important;
}
.menu-container .menu-help-container ::ng-deep svg-icon svg :is(path, circle, rect, line, ellipse, polyline, polygon) {
  color: #1E31BF !important;
  stroke: #1E31BF !important;
}
.menu-container .menu-help-container ::ng-deep svg-icon svg g {
  color: #1E31BF !important;
}
.menu-container .menu-help-container ::ng-deep svg-icon svg g :is(circle, line) {
  stroke: #1E31BF !important;
}
.menu-container .menu-help-container:hover {
  background-color: #F5F7FA;
  cursor: pointer;
}
.menu-container .menu-user-container .menu-user-admin-container {
  height: 6.25rem;
  width: 6.25rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  position: relative;
}
.menu-container .menu-user-container .menu-user-avatar-container {
  width: 6.25rem;
  height: 6.25rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  position: relative;
  border-top: 0.0625rem solid #EBEBEB;
}
.menu-container .menu-user-container .menu-user-avatar-container .border-left {
  width: 0.25rem;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #1E31BF;
  display: none;
}
.menu-container .menu-user-container .menu-user-avatar-container.active {
  background: #F5F7FA;
}
.menu-container .menu-user-container .menu-user-avatar-container.active .border-left {
  display: block;
}
.menu-container .menu-user-container .menu-user-avatar-container:focus {
  outline: none;
}
.menu-container .menu-user-container .menu-user-avatar-container .logout-control {
  position: absolute;
  width: 2.75rem;
  height: 2.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 0.0625rem solid #1E31BF !important;
  background-color: rgba(30, 49, 191, 0.48) !important;
}
.menu-container .menu-user-container .menu-user-avatar-container .logout-control svg path {
  fill: #FFFFFF;
  color: #FFFFFF;
}
.menu-container .menu-user-container .menu-user-avatar-container .logout-control:hover {
  cursor: pointer;
}
.menu-container .menu-user-container .menu-user-avatar-container:hover {
  cursor: pointer;
}
@media (prefers-color-scheme: dark) {
  .menu-container.dark-mode {
    background-color: #2B2B2B;
  }
  .menu-container.dark-mode .menu-app-icon {
    border-bottom: 0.0625rem solid #6A6A6A;
  }
  .menu-container.dark-mode .menu-user-container .menu-user-avatar-container {
    border-top: 0.0625rem solid #6A6A6A;
  }
  .menu-container.dark-mode .menu-user-container .menu-user-avatar-container:hover,
  .menu-container.dark-mode .menu-user-container .menu-user-avatar-container.active {
    background-color: #222222;
  }
  .menu-container.dark-mode .menu-user-container .menu-user-avatar-container.active {
    border-left: 0.25rem solid white !important;
  }
  .menu-container.dark-mode .menu-items-container .menu-item {
    border-top-color: #6A6A6A !important;
    border-bottom-color: #6A6A6A !important;
    background-color: #2B2B2B;
  }
  .menu-container.dark-mode .menu-items-container .menu-item .menu-icon-svg {
    color: #757575;
  }
  .menu-container.dark-mode .menu-items-container .menu-item:hover,
  .menu-container.dark-mode .menu-items-container .menu-item.active {
    background-color: #3C3C3C;
  }
  .menu-container.dark-mode .menu-items-container .menu-item.active {
    border-left: 0.25rem solid white !important;
  }
  #editModeOverlay {
    background-color: #222222;
  }
}
.powered-by {
  text-align: center;
  padding: 0.5rem;
  border-top: 0.0625rem solid #EAEAEA;
}
.powered-by a {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.powered-by a:focus,
.powered-by a:focus-visible,
.powered-by a:focus-within {
  outline: none;
  border: 0;
}
/*# sourceMappingURL=centrui-menu.component.css.map */
